import { useState } from 'react';

type UseCopyToClipboardReturnValue = {
  tooltipText: string;
  handleCopy: () => Promise<void>;
};

export function useCopyToClipboard(value: string): UseCopyToClipboardReturnValue {
  const [tooltipText, setTooltipText] = useState('');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setTooltipText('Скопировано');
      setTimeout(() => setTooltipText(''), 1000);
    } catch (e: unknown) {
      setTooltipText('Копирование не удалось');
    }
  };

  return { tooltipText, handleCopy };
}
